import React, { Component } from 'react';
import superagent from 'superagent';
import ReactLoading from 'react-loading';
import Header from './Header';
import * as jsPDF from 'jspdf';
import html2canvas from 'html2canvas';



class PaySlip extends Component {
    constructor(props)
    {
        super(props);

        this.fetchPaySlip = this.fetchPaySlip.bind(this);
        this.generatePDF = this.generatePDF.bind(this);
        this.updateYear = this.updateYear.bind(this);
        this.updateMonth = this.updateMonth.bind(this);
        this.fetchSalaryPeriods = this.fetchSalaryPeriods.bind(this);


        this.state = {
            user_details:this.props.user_details,
            access_token:this.props.access_token,
            selectedYear: "0",
            selectedPeriod: {},
            selectedMonth:"0",
            filteredPeriods:[],
            salaryMonths : [],
            years: [],

            apiError: true,
            apiResponse:"",
            earnings:[],
            deductions:[],
            grossPay: 0,
            totalDeductions:0,
            netPayable:0,
            maxAllowable:0,
            nonCashBenefit:0,
            grossPayTwo:0,
            taxablePay:0,
            pension:0,
            epension:0,
            lessAllowablePension:0.00,
            totalPension:0,
            additionalInfo:[],

            grade: "",


            api_loading:false,
            api_loading_message:"",
            loading:false,
            loaded_successfully:false,
            api_error_message:"",
            mode:0,
            server_changes_made:false

        }
    }


    updateYear(event)
      {
        console.log("selected year", event.target.value );

          if(event.target.value !== "0")
          {
            let tempPeriods = [];

            for(let k = 0; k< this.state.salaryPeriods.length; k++)
            {
              if(this.state.salaryPeriods[k].RYear === event.target.value)
              {
                tempPeriods.push(this.state.salaryPeriods[k]);
              }

            }

            this.setState({filteredPeriods:tempPeriods, selectedYear:event.target.value, selectedMonth:"0", server_changes_made:false });

          }
          else {
            this.setState({filteredPeriods:[], selectedYear:event.target.value, selectedMonth:"0", server_changes_made:false });
          }

      }

    updateMonth(event)
        {
                if(event.target.value !== "0")
                {
                  let selPeriod = {};

                    for(let k = 0; k< this.state.filteredPeriods.length; k++)
                    {
                        if(this.state.filteredPeriods[k].Names === event.target.value)
                        {
                          selPeriod = this.state.filteredPeriods[k];
                          break;
                        }

                    }

                  this.setState({selectedPeriod:selPeriod, selectedMonth:event.target.value, server_changes_made:false });

                }
                else {
                  this.setState({selectedPeriod:{}, selectedMonth:event.target.value, server_changes_made:false });
                }
        }

  generatePDF()
  {
    const input = document.getElementById('pay-slip');

    html2canvas(input)
    .then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF();
        pdf.addImage(imgData, 'PNG', 10, 20, 190, 267);
        let filename = "Payslip_"+this.state.selectedMonth + "_" + this.state.selectedYear;
        filename = filename + "_"+this.props.staff_details.core_details.EmpNo;
        filename = filename+".pdf";
        filename= filename.replace(/\s/g, "");
        pdf.save(filename);
      });

  }

  emailPayslip()
  {
    //var attachments = [{ filename: 'test.pdf', path: __dirname + '/pdf/test.pdf', contentType: 'application/pdf' }];
  }


  fetchPaySlip()
  {

            this.setState({loading:true});
            let _this = this;

            const url = this.props.base_url +"/staff/payslip";


            superagent
            .post(url)
            .send({emp_number:_this.props.staff_details.core_details.EmpNo,
                    speriod:this.state.selectedPeriod})
            .set('Accept', 'application/json')
            .set('Content-Type', 'application/json')
            .then(function(res){
                //res.body, res.headers, res.status
                let error = res.body.error;
                console.log("Response", res.body);


                _this.setState({apiError:res.body.error,
                                apiResponse:res.body.message,
                                earnings: res.body.earnings,
                                deductions: res.body.deductions,
                                grossPay: res.body.gross_pay,
                                grossPayTwo: res.body.gross_pay_two,
                                totalDeductions: res.body.total_deductions,
                                netPayable: res.body.net_payable,
                                taxablePay:res.body.taxable_pay,
                                maxAllowable:res.body.max_allowable,
                                nonCashBenefit:res.body.non_cash_benefit,
                                additionalInfo:res.body.additional_info,
                                pension:res.body.pension,
                                epension:res.body.epension,
                                grade:res.body.pgrade +"(" + res.body.prank + ")",
                                lessAllowablePension:res.body.less_allowable_pension,
                                totalPension:res.body.total_pension,
                                loading:false, loaded_successfully:true,server_changes_made:true});

            })
            .catch(function(err){

                console.log("error response", err);
                _this.setState({loading:false, apiError:true,loaded_successfully:false, apiResponse:err,server_changes_made:true});
            });

  }


  fetchSalaryPeriods()
  {

            this.setState({loading:true});
            let _this = this;

            const url = this.props.base_url +"/staff/getsalaryperiods";

            superagent
            .get(url)
            .send()
            .set('Accept', 'application/json')
            .set('Content-Type', 'application/json')
            .then(function(res){
                //res.body, res.headers, res.status
                let error = res.body.error;

                console.log(" s periods ", res.body);





                _this.setState({apiError:res.body.error,
                                apiResponse:res.body.message,
                                years: res.body.years,
                                filteredMonths:[],
                                salaryPeriods: res.body.salary_periods,
                                loading:false, loaded_successfully:true,server_changes_made:true});

            })
            .catch(function(err){

                console.log("error response", err);
                _this.setState({loading:false,
                                years: [],
                                filteredMonths:[],
                                salaryPeriods: [], apiError:true,loaded_successfully:false, apiResponse:err,server_changes_made:true});
            });

  }





  renderErrorMessage()
  {
    const _this = this;

      if(this.state.apiError && !this.state.loading)
      {
          return(
            <div className="loading-progress">
                <div className="error-message">
                    <p>{_this.state.apiResponse}</p>
                </div>
            </div>
          );
      }
      else
      {
        return null;
      }

  }

  renderLoadingProgress()
  {
    const _this = this;
      if(this.state.api_loading)
      {
          return(
            <div className="loading-progress">
            <div >
                {_this.state.api_loading_message}
                <ReactLoading className="loading-progress" type="spinningBubbles" color="#000" height="40"  />
            </div>
        </div>

          );
      }
      else{
          return null;
      }
  }

  renderPaySlipPeriod()
  {
    const _this = this;
      if(_this.state.selectedYear != 0 && _this.state.selectedMonth != 0 && _this.state.server_changes_made)
      {
          return(
            <span className= "transcript-period">
                  {" - ("+ _this.state.selectedPeriod.Names + ")"} 
            </span>

          );
      }
      else{
          return null;
      }
  }

  renderDownloadButton()
  {
    const _this = this;
      if( ! _this.state.apiError && _this.state.server_changes_made && !(this.state.selectedYear == 0 || this.state.selectedMonth == 0))
      {
          return(
                <span>
              
                  <button className="btn btn-primary btn-round" onClick={_this.generatePDF.bind(_this)} onTap={_this.generatePDF.bind(_this)}  >Download<div className="ripple-container"></div></button>

                </span>
                

          );
      }
      else{
          return null;
      }
  }



  renderPaySlip()
  {
    const _this = this;
    let additional_block;

    if((this.state.selectedYear == 0 || this.state.selectedMonth == 0) || !(this.state.server_changes_made))
    {
      return(<p className="full-width text-center" style = {{paddingTop:'15px', paddingBottom:'15px'}}> Select Month and Year then click the Submit button to view Pay Slip </p>);
    }
    else if(this.state.apiError)
    {
      return(<p className="full-width text-center" style = {{paddingTop:'15px', paddingBottom:'15px'}}> {_this.state.apiResponse}</p>);
    }
    else
    {
        let incomeListing = _this.state.earnings.map((income) => {

                return(
                  <span className = "row full-width">
                    <span className="col-lg-6">{income.pay}</span>
                    <span className="col-lg-2"></span>
                    <span className="col-lg-3 right-align">{_this.props.renderInThousands(income.amount)}</span>
                  </span>
                );
        });

        let deductionListing = _this.state.deductions.map((deduction) => {

                return(
                  <span className = "row full-width">
                    <span className="col-lg-6">{deduction.deduction}</span>
                    <span className="col-lg-2"></span>
                    <span className="col-lg-3 right-align">{_this.props.renderInThousands(deduction.amount)}</span>
                  </span>
                );
        });

        if(this.state.additionalInfo.length > 0)
        {
          let blocklisting = _this.state.additionalInfo.map((info) => {
                  return(
                    <span className = "row full-width">
                      <span className="col-lg-6">{info.name}</span>
                      <span className="col-lg-2"></span>
                      <span className="col-lg-3 right-align">{_this.props.renderInThousands(info.amount)}</span>
                    </span>
                  );
              });

            additional_block = <div className ="ps-block personal-details col-lg-11 justified">
                <span className = "row full-width">
                  <span className="col-lg-6 ps-header">Additional Information </span>
                  <span className="col-lg-3 ps-header"></span>
                  <span className="col-lg-3 ps-header"></span>
                </span>

                {blocklisting}

            </div>
        }
        else {
           additional_block =null;
        }



          return (
            <div className="full-width" id = "pay-slip">

                <div className = "payslip-header">
                  <center> <img src ="/img/logotuc.png" className="header-logo center"/> </center>
                  <h3 className = "text-center">TURKANA UNIVERSITY COLLEGE</h3>
                  <h6 className = "text-center"> {"PAYSLIP - " + _this.state.selectedMonth + "  "+ _this.state.selectedYear} </h6>

                  <div className ="ps-block personal-details col-lg-11 justified">
                      <span className = "row full-width">
                        <span className="col-lg-4 bold"> NAME: </span>
                        <span className="col-lg-8">{_this.props.staff_details.core_details.Names + " ["+ _this.props.staff_details.core_details.EmpNo+"]"}</span>
                      </span>

                      <span className = "row full-width">
                        <span className="col-lg-4 bold"> PIN No: </span>
                        <span className="col-lg-8"> {_this.props.staff_details.core_details.PIN}</span>
                      </span>

                      <span className = "row full-width">
                        <span className="col-lg-4 bold"> DESIGNATION: </span>
                        <span className="col-lg-8"> {_this.props.staff_details.core_details.JobTitle}</span>
                      </span>

                      <span className = "row full-width">
                        <span className="col-lg-4 bold"> PAY GRADE: </span>
                        <span className="col-lg-8"> {"GRADE " + _this.state.grade}</span>
                      </span>

                      <span className = "row full-width">
                        <span className="col-lg-4 bold"> DEPARTMENT: </span>
                        <span className="col-lg-8"> {_this.props.staff_details.core_details.Department}</span>
                      </span>

                  </div>

                  <div className ="ps-block personal-details col-lg-11 justified">
                      <span className = "row full-width">
                        <span className="col-lg-6 ps-header"> Pay </span>
                        <span className="col-lg-2 ps-header"></span>
                        <span className="col-lg-3 ps-header right-align"> Amount</span>
                        <span className="col-lg-1 ps-header"></span>
                      </span>

                      {incomeListing}

                      <span className = "row full-width">
                        <span className="col-lg-6 ps-header">Gross Pay </span>
                        <span className="col-lg-2 ps-header"></span>
                        <span className="col-lg-3 ps-header right-align">{_this.props.renderInThousands(_this.state.grossPay)}</span>
                        <span className="col-lg-1 ps-header"></span>
                      </span>

                  </div>


                  <div className ="ps-block personal-details col-lg-11 justified">
                      <span className = "row full-width">
                        <span className="col-lg-6 ps-header"> Deduction </span>
                        <span className="col-lg-2 ps-header"></span>
                        <span className="col-lg-3 ps-header right-align"> Amount</span>
                        <span className="col-lg-1 ps-header"></span>
                      </span>

                      {deductionListing}

                      <span className = "row full-width">
                        <span className="col-lg-6 ps-header"> Total Deductions </span>
                        <span className="col-lg-2 ps-header"></span>
                        <span className="col-lg-3 ps-header right-align"> {_this.props.renderInThousands(_this.state.totalDeductions)}</span>
                        <span className="col-lg-1 ps-header"></span>
                      </span>

                  </div>

                  <span className = "row col-lg-11 justified border-under">
                    <span className="col-lg-6"> Net Payable (Income - Deductions) </span>
                    <span className="col-lg-3 right-align">{_this.props.renderInThousands(_this.state.netPayable)}</span>
                    <span className="col-lg-1 ps-header"></span>
                  </span>

                  

                  <div className ="personal-details col-lg-11 justified">
                      <span className = "row full-width" style = {{marginBottom:"5px"}}>
                        <span className="col-lg-6 ps-header">PAYE Information</span>
                        <span className="col-lg-5 "></span>
                      </span>

                      <span className = "row full-width">
                        <span className="col-lg-6">Gross Pay:</span>
                        <span className="col-lg-2 ps-header"></span>
                        <span className="col-lg-3 ps-header right-align">{_this.props.renderInThousands(_this.state.grossPay)}</span>
                        <span className="col-lg-1 ps-header"></span>
                      </span>

                      <span className = "row full-width">
                        <span className="col-lg-6">Total Pension</span>
                        <span className="col-lg-2 ps-header right-align">{_this.props.renderInThousands(_this.state.totalPension)}</span>
                          <span className="col-lg-4 ps-header right-align"></span>
                      </span>

                      <span className = "row full-width">
                          <span className="col-lg-6">Maximum Allowable</span>
                          <span className="col-lg-2 ps-header right-align border-under">
                              {_this.props.renderInThousands(_this.state.maxAllowable)}
                          </span>
                          <span className="col-lg-4 ps-header"></span>
                      </span>

                      <span className = "row full-width">
                        <span className="col-lg-6">Non Cash Benefit</span>
                        <span className="col-lg-2 ps-header border-under right-align">{_this.props.renderInThousands(_this.state.nonCashBenefit)}</span>
                          <span  className="col-lg-3 ps-header border-under right-align">{_this.props.renderInThousands(_this.state.nonCashBenefit)}</span>
                          <span className="col-lg-1 ps-header"></span>
                      </span>

                      <span className = "row full-width">
                        <span className="col-lg-6"></span>
                        <span className="col-lg-2"></span>
                        <span className="col-lg-3 ps-header right-align">{_this.props.renderInThousands(_this.state.grossPayTwo)}</span>
                        <span className="col-lg-1 ps-header"></span>
                          
                      </span>

                      <span className = "row full-width">
                        <span className="col-lg-6">Less Allowable Pension</span>
                        <span className="col-lg-2 ps-header"></span>
                        <span className="col-lg-3 ps-header border-under right-align">{_this.props.renderInThousands(_this.state.lessAllowablePension)}</span>
                        <span className="col-lg-1 ps-header"></span>
                         
                      </span>

                      <span className = "row full-width border-under">
                        <span className="col-lg-6">Taxable Pay</span>
                        <span className="col-lg-2 ps-header"></span>
                        <span className="col-lg-3 ps-header right-align">{_this.props.renderInThousands(_this.state.taxablePay)}</span>
                        <span className="col-lg-1 ps-header"></span>
                        
                      </span>
                  </div>
                  {additional_block}


                </div>
            </div>
          );
    }


  }

  componentWillMount()
  {
    this.fetchSalaryPeriods();
  }


  render() {

    const _this=this;

    let yearListing = this.state.years.map((yr) => {

      console.log("year", yr);

      return(
        <option value={yr.RYear}>{yr.RYear}</option>

      );
    });

    console.log("Yar listing ", yearListing);

    let monthListing = this.state.filteredPeriods.map((prd) => {
      return(
        <option value={prd.Names}>{prd.Names}</option>
      );
    });


    if(this.state.loading)
    {
        return(

            <div className="main-panel">

              <Header title = "PaySlip" />


              <div className="content">
                  <div className="container-fluid">
                      <div className="row">
                        Loading PaySlip, Please wait......
                        <ReactLoading className="loading-progress" type="bars" color="#000" height="100px" width="120px"  />
                      </div>
                </div>
              </div>
            </div>

        );
    }

    return (
      <div className="main-panel">

        <Header title ="PaySlip" />

        <div className="content">
            <div className="container-fluid">



            <div className="row full-width">
                    <div className="col-lg-12 col-md-12">
                        <div className="card full-width">
                            <div className="card-body">
                                <div className="tab-content block-centered">
                                    <div className="tab-pane active" id="profile">
                                        <h4 className ="text-center" style ={{fontWeight:"style"}}>PAYSLIP {_this.renderPaySlipPeriod()} {_this.renderDownloadButton()} </h4>

                                        <div className="row full-width block-centered col-lg-8">
                                            <div className="col-lg-4">
                                                YEAR :
                                                <select type="select" value={_this.state.selectedYear} className="select-box" onChange = {this.updateYear.bind(_this)}>
                                                  <option value="0">Select Year</option>
                                                    {yearListing}
                                                </select>
                                            </div>

                                            <div className="col-lg-4">
                                                Month:
                                                <select type="select" value={_this.state.selectedMonth} className="select-box" onChange = {this.updateMonth.bind(_this)}>
                                                  <option value="0">Select Month</option>
                                                    {monthListing}
                                                </select>
                                            </div>

                                            <div className="col-lg-4 block-centered">
                                                <button className="btn btn-primary btn-round" type="submit" style ={{marginTop:'20px'}} onClick={_this.fetchPaySlip.bind(_this)} onTap={_this.fetchPaySlip.bind(_this)} disabled={_this.state.selectedYear == 0 || _this.state.selectedMonth == 0} >Submit<div className="ripple-container"></div></button>
                                            </div>
                                        </div>

                                        {_this.renderPaySlip()}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

            </div>

            </div>
            </div>
            </div>





    );
  }
}

export default PaySlip;
